"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBorderWidthForMatting = exports.getOrientation = void 0;
const artConsts_1 = require("../consts/artConsts");
const matting_1 = require("../consts/matting");
const getOrientation = ({ width, height }) => {
    const ratio = width / height;
    const orientation = ratio > 1.1
        ? artConsts_1.PHOTO_ORIENTATIONS.LANDSCAPE
        : ratio < 0.9
            ? artConsts_1.PHOTO_ORIENTATIONS.PORTRAIT
            : artConsts_1.PHOTO_ORIENTATIONS.SQUARE;
    return orientation;
};
exports.getOrientation = getOrientation;
function getBorderWidthForMatting(matting, photoOrientation, tileSize) {
    const mattingOrientationToBorderWidth = matting_1.MATTING_TO_BORDER_WIDTH[matting];
    if (!mattingOrientationToBorderWidth) {
        return undefined;
    }
    // Prioritize size-specific matting over general matting
    return mattingOrientationToBorderWidth[tileSize] || mattingOrientationToBorderWidth[photoOrientation];
}
exports.getBorderWidthForMatting = getBorderWidthForMatting;
//# sourceMappingURL=matting.js.map